import React, {useState} from 'react';
import { useShortURL } from './API/Api';
import {handleCopyClick, handleShareClick } from './js/utility';

const AppModal = ({ selectedApp }) => {
    const App = selectedApp;
    
    const click_url = App?.redirect_url;
    const payout_vc = App ? (App.payout_usd * 2000) : 0;

    const { shortURL, error, loading } = useShortURL(click_url);
    const [copyStatus, setCopyStatus] = useState(false);

    return (
        <div className="modal fade" id="appModal" tabIndex="-1" aria-labelledby="appModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-black" id="appModalLabel">Offer #{App?.id}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {App && (
                          <>    
                            <div className="d-flex mb-3">
                                <div className="flex-shrink-0">
                                    <img className="imaged img-fluid border rounded-md shadow" src={App.app_icon} alt={App.app_name} style={{ width: "150px" }} />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p className='text-black'>{App.app_name}</p>
                                    <p className="card-text mb-1">
                                        <small className="text-muted">
                                            {App.conversions === 0 ? '' : (
                                                <span>{App.conversions} <i className="bi bi-people" title="Users"></i> earned {App.conversions * App.payout_vc} coins.</span>
                                            )}
                                        </small>
                                    </p>
                                    <p className="text-muted mb-2">{App.description}</p>
                                    <small className="text-muted" dangerouslySetInnerHTML={{ __html: coreTSW.convertToBadge('platformToLabel', App.platform, App) }}></small>                                    
                                </div>
                            </div>
                            <div className="alert alert-outline-primary fade show" role="alert">
                                <h4 className="alert-title">Task</h4>
                                <span className="text-muted" dangerouslySetInnerHTML={{ __html: corePYK.payoutTypeToAction(App.payout_type, App) }}></span>
                            </div>  
                          </>                                
                        )}                      
                    </div>
                    <div className="modal-footer">
                        <div className="btn-group btn-block" role="group">
                            <a className="btn btn-warning btn-block" href={click_url} target="_blank" style={{ width: "100%" }}>
                                <i className="bi bi-plus m-0"></i> {payout_vc} 
                                <span className="Xd-noneX Xd-sm-blockX">&nbsp;$COIN</span>
                            </a>
                        </div>
                    </div>                    
                    {shortURL && (
                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-md-6 text-center">
                                    <img className="img-fluid img-responsive p-1" src={`${shortURL}/qr`} alt="QR Code" style={{width: '200px'}} />
                                </div>
                                <div className="col-md-6">
                                    <div className="btn-group btn-block mt-1 mb-1">
                                        <button className="btn btn-outline-secondary btn-block" type="button" onClick={() => handleCopyClick(shortURL, setCopyStatus)}>
                                            {shortURL}
                                            <i className={`bi ${copyStatus ? 'bi-check-circle' : 'bi-clipboard'} ms-2`}></i>
                                        </button>
                                    </div>
                                    <a className="btn btn-whatsapp btn-block mt-1 mb-1" href={`https://wa.me/?text=${encodeURIComponent(shortURL)}`} target="_blank">
                                        <i className="bi bi-whatsapp"></i>
                                        Share via WhatsApp
                                    </a>
                                    <button className="btn btn-outline-primary btn-block mt-1 mb-1" type="button" onClick={() => handleShareClick(App?.name, App?.name, shortURL)}>
                                        <i className="bi bi-share"></i>
                                        Share via Apps
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppModal;
